import { render, staticRenderFns } from "./CounponWizardStep.vue?vue&type=template&id=72b0c1fc&scoped=true"
import script from "./CounponWizardStep.vue?vue&type=script&lang=js"
export * from "./CounponWizardStep.vue?vue&type=script&lang=js"
import style0 from "./CounponWizardStep.vue?vue&type=style&index=0&id=72b0c1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0c1fc",
  null
  
)

export default component.exports